import * as Sentry from "@sentry/react-native"
import { type UserFeedback } from "@sentry/react-native"
import { type UserType } from "@/generated/graphql"

const MESSAGE_TYPES = {
  UNEXPECTED_ERROR: "An unexpected feedback error has occurred",
  REDFIN_FEEDBACK_SUCCESS: "Redfin Market Data User Feedback",
}

/**
 * Send a message to Sentry and user feedback, then simulate a callback for success or error.
 * @param {UserType} user User object containing first name, last name, and email.
 * @param {string} feedbackMessage The feedback message from the user.
 * @returns {Promise<string>} A promise that resolves with a success message or rejects with an Error.
 */
export async function sendFeedbackToSentry(
  user: UserType,
  feedbackMessage: string,
  canContact: boolean,
  feedbackTitle: string = MESSAGE_TYPES.REDFIN_FEEDBACK_SUCCESS
): Promise<string> {
  try {
    const eventId = Sentry.captureMessage(
      `${feedbackTitle} (${canContact ? "Okay to Contact" : "Do not Contact"})`
    )

    if (eventId) {
      const userFeedback: UserFeedback = {
        event_id: eventId,
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        comments: feedbackMessage,
      }

      Sentry.captureUserFeedback(userFeedback)
      // console.log(`Feedback sent successfully: ${JSON.stringify(userFeedback)}`)

      return "Feedback Successfully Sent!"
    } else {
      throw new Error("Failed to send event to Sentry.")
    }
  } catch (error) {
    throw new Error(
      `Error sending event and feedback to Sentry: ${error as string}`
    )
  }
}
